let sent = 0;

export function reportClientError(message, stack, context = "") {
  try {
    if (sent >= 3) return;
    sent += 1;
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/client-errors`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        message: String(message || "").slice(0, 500),
        stack: String(stack || "").slice(0, 3000),
        context: String(context || "").slice(0, 200),
        url: window.location.href,
        user_agent: navigator.userAgent,
        user_email: (() => {
          try {
            const t = localStorage.getItem("access_token");
            if (!t) return null;
            const p = JSON.parse(atob(t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/")));
            return p.email || p.sub || null;
          } catch { return null; }
        })(),
        token_present: !!localStorage.getItem("access_token"),
      }),
      keepalive: true,
    }).catch(() => {});
  } catch { /* nunca romper por el reporter */ }
}

export function installGlobalErrorReporting() {
  window.addEventListener("error", (e) => {
    reportClientError(e.message, e.error?.stack, "window.onerror");
  });
  window.addEventListener("unhandledrejection", (e) => {
    const r = e.reason;
    reportClientError(r?.message || String(r), r?.stack, "unhandledrejection");
  });
}
